import { request } from './apiClient';
import { getSessionClientId } from './authSession';

// Mantém só os dígitos da string.
const onlyDigits = (value) => (value || '').replace(/\D/g, '');

// Monta o payload de obra (camelCase) a partir do formulário.
// AJUSTE BACKEND AQUI: mapeamento do formulario para o contrato da API de obra.
export const buildObraPayload = (formData, cnpjDigits, cepDigits) => ({
  nomeObra: formData.nomeObra.trim(),
  numrCnpj: cnpjDigits || onlyDigits(formData.numrCnpj),
  endereco: formData.endereco.trim(),
  codgCep: cepDigits ? Number(cepDigits) : null,
  idCidade: formData.idCidade ? Number(formData.idCidade) : null,
  idCliente: formData.idCliente || getSessionClientId() || null,
  idEmpresa: formData.idEmpresa || null,
  // AJUSTE BACKEND AQUI: FKs de contato da obra (técnico/financeiro/administrativo).
  idContatoTecnico: formData.idUsuarioTecnico || null,
  idContatoFinanceiro: formData.idUsuarioFinanceiro || null,
  idContatoAdministrativo: formData.idUsuarioAdministrativo || null,
  flagRelatorioCor: formData.flagRelatorioCor,
  flagObrFotoResultado: formData.flagObrFotoResultado,
  flagReviConcRealizada: formData.flagReviConcRealizada,
  flagReviCorpoProva: formData.flagReviCorpoProva,
  flagReviResuCorpoProva: formData.flagReviResuCorpoProva,
});

// Lista todas as obras.
export const getObras = async (idCliente) => {
  // AJUSTE BACKEND AQUI: endpoint de listagem de obras.
  const effectiveClientId = idCliente || getSessionClientId();
  return await request(`/api/obra?idCliente=${effectiveClientId}`);
};

// Cria uma obra; retorna { response, payload }.
export const createObra = async (formData, cnpjDigits, cepDigits) => {
  const payload = buildObraPayload(formData, cnpjDigits, cepDigits);

  // AJUSTE BACKEND AQUI: endpoint de criacao de obra.
  const response = await request('/api/obra', {
    method: 'POST',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Atualiza a obra por id; retorna { response, payload }.
export const updateObra = async (id, formData, cnpjDigits, cepDigits) => {
  const payload = buildObraPayload(formData, cnpjDigits, cepDigits);
  payload.idObra = Number(id);

  // AJUSTE BACKEND AQUI: update por id da obra.
  const response = await request(`/api/obra/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Exclui a obra por id.
export const deleteObraApi = async (id) => {
  // AJUSTE BACKEND AQUI: exclusao por id da obra.
  return await request(`/api/obra/${id}`, {
    method: 'DELETE'
  });
};